import {
  MODAL_FIX_CLOSE,
  MODAL_FIX_NEXT_STEP,
  MODAL_FIX_OPEN,
  MODAL_FIX_PREV_STEP,
  MODAL_FIX_SET_NEXT_DISABLED_FOR_CURRENT_STEP,
  MODAL_FIX_SKIP_STEP,
  MODAL_FIX_TRIGGER_NEXT,
  MODAL_FIX_UPDATE_FEATURE_ID,
  STORE_SNAPSHOT
} from "../../actions/actionTypes";

const initialState = {
  id: '',
  isModalFixOpen: false,
  currentStep: 1,
  totalSteps: 1,
  title: '',
  content: null,
  showSkip: false,
  showPrev: false,
  showNext: true,
  showClose: true, // Show close button by default
  showCancel: false, // Hide cancel button by default
  nextButtonText: 'Next',
  skipButtonText: 'Skip',
  isNextButtonDisabled: false,
  onComplete: null,
  enterAnim: 'fadeDown',
  exitAnim: 'fadeUp',
  animDurationMs: 750,
  animOffsetPx: 50,
  steps: [],
  snapshot: null,
  isSquareFootageEnabledOnOpen: false,
};

const updateStepData = (state, stepIndex) => {
  const currentStepData = state.steps[stepIndex];
  return {
    ...state,
    title: currentStepData.title,
    content: currentStepData.content,
    showSkip: currentStepData.showSkip || false,
    showCancel: currentStepData.showCancel !== undefined ? currentStepData.showCancel : false,
    showClose: currentStepData.showClose !== undefined ? currentStepData.showClose : true,
    isSQFTStep: currentStepData.isSQFTStep || false,
    featureId: currentStepData.featureId || null,
    featureName: currentStepData.featureName || null,
    showPrev: currentStepData.showPrev !== false,
    showNext: currentStepData.showNext !== false,
    nextButtonText: currentStepData.nextButtonText || 'Next',
    skipButtonText: currentStepData.skipButtonText || 'Skip',
    enterAnim: currentStepData.enterAnim || 'fadeDown',
    exitAnim: currentStepData.exitAnim || 'fadeUp',
    animDurationMs: currentStepData.animDurationMs || 750,
    animOffsetPx: currentStepData.animOffsetPx || 50,
    isNextButtonDisabled: currentStepData.isNextButtonDisabled || false,
  };
};

const modalFixReducer = (state = initialState, action) => {
  switch (action.type) {
    case MODAL_FIX_OPEN: {
      const { id, steps, isSquareFootageEnabledOnOpen, onComplete } = action.payload;
      const newState = {
        ...state,
        id: id,
        isModalFixOpen: true,
        steps: steps,
        totalSteps: steps.length,
        currentStep: 1,
        onComplete: onComplete,
        showPrev: false, // First step never shows prev
        isSquareFootageEnabledOnOpen: !!isSquareFootageEnabledOnOpen,
      };

      // Set current step data
      return updateStepData(newState, 0);
    }

    case MODAL_FIX_CLOSE:
      return {
        ...initialState
      };

    case MODAL_FIX_NEXT_STEP:
    case MODAL_FIX_TRIGGER_NEXT: {
      if (state.currentStep < state.totalSteps) {
        const newState = {
          ...state,
          currentStep: state.currentStep + 1,
          //showPrev: true
        };

        // Update step data
        return updateStepData(newState, newState.currentStep - 1);
      } else {
        // Last step completed
        if (state.onComplete && typeof state.onComplete === 'function') {
          state.onComplete();
        }
        return {
          ...initialState
        };
      }
    }

    case MODAL_FIX_PREV_STEP: {
      if (state.currentStep > 1) {
        const newState = {
          ...state,
          currentStep: state.currentStep - 1,
          showPrev: state.currentStep - 1 > 1
        };

        // Update step data
        return updateStepData(newState, newState.currentStep - 1);
      }
      return state;
    }

    case MODAL_FIX_SKIP_STEP: {
      // Skip to completion
      if (state.onComplete && typeof state.onComplete === 'function') {
        state.onComplete();
      }
      return {
        ...initialState
      };
    }

    case MODAL_FIX_UPDATE_FEATURE_ID: {
      const { featureId, featureName } = action.payload;
      const currentStepIndex = state.currentStep - 1;

      // Update both steps array and current step state
      const updatedSteps = [...state.steps];
      if (updatedSteps[currentStepIndex]) {
        updatedSteps[currentStepIndex] = {
          ...updatedSteps[currentStepIndex],
          featureId: featureId,
          featureName: featureName
        };
      }

      return {
        ...state,
        featureId: featureId,
        featureName: featureName,
        steps: updatedSteps
      };
    }
    case STORE_SNAPSHOT: {
      return Object.assign({}, state, {
        ...action.payload
      });
    }
    case MODAL_FIX_SET_NEXT_DISABLED_FOR_CURRENT_STEP: {
      const currentStepIndex = state.currentStep - 1;
      const isDisabled = !!action.payload?.isDisabled;

      const updatedSteps = [...state.steps];

      if (updatedSteps[currentStepIndex]) {
        updatedSteps[currentStepIndex] = {
          ...updatedSteps[currentStepIndex],
          isNextButtonDisabled: isDisabled
        };
      }

      return {
        ...state,
        isNextButtonDisabled: isDisabled,
        steps: updatedSteps
      };
    }

    default:
      return state;
  }
};

export default modalFixReducer;
